declare namespace $ {

	type $mol_view__sub_shm_hitalama_map_history_view_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_history_view_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_hitalama_map_history_view_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_history_view['undo_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_history_view_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_history_view['undo'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_history_view_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_hitalama_map_history_view_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_history_view['redo_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_history_view_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_history_view['redo'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_history_view_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_history_view_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_history_view['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_history_view_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_history_view_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_hitalama_map_history_view_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_history_view['event_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_list__Empty_shm_hitalama_map_history_view_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_history_view['No_events'] >
		,
		ReturnType< $mol_list['Empty'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_history_view_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_hitalama_map_history_view_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_history_view['earlier_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_history_view_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_history_view['earlier_load'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_history_view_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_history_view['event_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_history_view_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_history_view['event_content'] >
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_history_view_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_history_view_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_history_view_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_history_view_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_history_view extends $mol_page {
		Title( ): $mol_view
		Head_spacer( ): $mol_view
		undo_enabled( ): boolean
		undo( next?: any ): any
		Undo( ): $mol_button_minor
		redo_enabled( ): boolean
		redo( next?: any ): any
		Redo( ): $mol_button_minor
		Close_icon( ): $mol_icon_close
		Close( ): $mol_button_minor
		event_rows( ): readonly($mol_view)[]
		No_events( ): $mol_view
		Events( ): $mol_list
		earlier_enabled( ): boolean
		earlier_load( next?: any ): any
		Earlier( ): $mol_button_minor
		event_toggle( id: any, next?: any ): any
		event_content( id: any): readonly($mol_view)[]
		map( ): $shm_hitalama_map
		close( next?: any ): any
		head( ): readonly(any)[]
		body( ): readonly(any)[]
		Event( id: any): $mol_button_minor
		Event_summary( id: any): $mol_view
		Event_title( id: any): $mol_view
		Event_meta( id: any): $mol_view
		Event_details( id: any): $mol_view
		expanded( id: any, next?: boolean ): boolean
	}
	
}

//# sourceMappingURL=view.view.tree.d.ts.map